export default {
  list: "list",
  update: "detail",
  create: "create",
}
